import React from 'react';
import logo from '../assets/images/musclecreatorlogo.png'; // Adjust the path as necessary

const Header: React.FC = () => {
    return (
        <header id="header" className="alt">
            <span className="logo"><img src={logo} alt="" width="100" height="100" style={{ borderRadius: '10%' }}/></span>
            <h1>Muscle Creator</h1>
            <p>Your fitness journey begins in Akola with us!<br />
                Owned by Suyog Tarole, Muscle Creator is dedicated to helping you achieve your fitness goals with state-of-the-art gym facilities and personalized training programs.</p>
        </header>
    );
}

export default Header;